import { toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "o-grid u-mar-t-2" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 u-form-grid-nospace-y" }
const _hoisted_3 = { class: "u-form-heading" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true ? "Kundendaten" : "Ihre Daten") + "  ", 1),
          _createElementVNode("a", {
            role: "button",
            tabindex: "0",
            class: "u-copy-s field-edit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('gehe-zu-antragsdaten', $event))),
            onKeydown: [
              _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('gehe-zu-antragsdaten', $event)), ["enter"])),
              _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('gehe-zu-antragsdaten', $event)), ["prevent"]), ["space"]))
            ],
            "aria-label": "Ihre Daten bearbeiten"
          }, "bearbeiten", 32)
        ])
      ])
    ]),
    (
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === '0001' ||
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === '0002'
    )
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 0,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Anrede/Titel")
              ])),
              _: 1,
              __: [3]
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "anredeTitel" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.getAnredeText) + "  " + _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.titel), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === '0003' ||
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === 'ETG' ||
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === 'WEG'
    )
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 1,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => [
                _createElementVNode("span", { innerHTML: _ctx.getAnredeText }, null, 8, _hoisted_4)
              ]),
              _: 1
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "organisation" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.organisation), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === '0001' ||
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === '0002' ||
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === '0003' ||
      _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede === 'Z001'
    )
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 2,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Vorname/Name")
              ])),
              _: 1,
              __: [4]
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "vornameNachname" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.vorname) + "  " + _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.nachname), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.piniaStore.state.personendaten.verwalterAktiv)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Post­leit­zahl/­Ort")
                ])),
                _: 1,
                __: [5]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "plzOrt" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getPlzOrtText), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Straße/Haus­nummer")
                ])),
                _: 1,
                __: [6]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "strasseHausnummer" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getStrasseHausnummerText), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.piniaStore.state.personendaten.versicherungsnehmer.email)
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 4,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("E-Mail")
              ])),
              _: 1,
              __: [7]
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "email" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.email), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.piniaStore.state.personendaten.versicherungsnehmer.telefon)
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 5,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Telefon")
              ])),
              _: 1,
              __: [8]
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "telefon" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.telefon), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" Ver­trags­unter­lagen per E-Mail")
            ])),
            _: 1,
            __: [9]
          }, 16),
          _createVNode(_component_zelle, _mergeProps({ "data-cy": "unterlagenDigital" }, _ctx.formatZelle), {
            default: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.getUnterlagenDigitalText), 1)
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      })
    ]),
    (_ctx.piniaStore.state.personendaten.versicherungsnehmer.mobil)
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 6,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Mobil­telefon")
              ])),
              _: 1,
              __: [10]
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "mobil" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.mobil), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.piniaStore.state.personendaten.verwalterAktiv)
      ? (_openBlock(), _createBlock(_component_zeile, {
          key: 7,
          class: "u-mar-t-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.formatTitelZelle)), {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode(" Ansprech­part­ner/Ver­wal­ter")
              ])),
              _: 1,
              __: [11]
            }, 16),
            _createVNode(_component_zelle, _mergeProps(_ctx.formatZelle, { "data-cy": "plzOrt" }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.getVerwalterText), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}